// assets
import { ContactSupport, RateReview, Loyalty, Assessment, TextSnippet, Description } from '@mui/icons-material';

import { DocumentGeneratorIcon } from 'components/icons/sidebarIcons';
// constant
export const icons = {
    TextSnippet,
    ContactSupport,
    RateReview,
    Loyalty,
    Assessment,
    Description
};

const documentGenerator = {
    id: 'document-generator',
    title: 'side_menu.document_generator',
    type: 'group',
    roles: ['user', 'subuser', 'member', 'supervisor', 'admin', 'demo', 'sales', 'superadmin', 'it'],
    collapse: false,
    icon: 'Description', //icons.Description,
    children: [
        {
            id: 'inquiry',
            title: 'side_menu.inquiry',
            type: 'item',
            url: 'new-document-generator/inquiry',
            icon: 'ContactSupport', //icons.ContactSupport,
            breadcrumbs: false,
            roles: ['user', 'subuser', 'member', 'supervisor', 'admin', 'demo', 'sales', 'superadmin', 'it'],
        },
        {
            id: 'proposal',
            title: 'side_menu.proposal',
            type: 'item',
            url: 'new-document-generator/proposal',
            icon: 'RateReview', //icons.RateReview,
            breadcrumbs: false,
            roles: ['user', 'subuser', 'member', 'supervisor', 'admin', 'demo', 'sales', 'superadmin', 'it'],
        },
        {
            id: 'thank-you-letter',
            title: 'side_menu.thank_you',
            type: 'item',
            url: 'new-document-generator/thank-you',
            icon: 'Loyalty', //icons.Loyalty,
            breadcrumbs: false,
            roles: ['user', 'subuser', 'member', 'supervisor', 'admin', 'demo', 'sales', 'superadmin', 'it'],
        },
        {
            id: 'impact-report-letter',
            title: 'side_menu.impact_report',
            type: 'item',
            url: 'new-document-generator/impact-report',
            icon: 'Assessment', //icons.Assessment,
            breadcrumbs: false,
            roles: ['user', 'subuser', 'member', 'supervisor', 'admin', 'demo', 'sales', 'superadmin', 'it'],
        },
        {
            id: 'custom-letter',
            title: 'side_menu.custom_letter',
            type: 'item',
            url: 'new-document-generator/custom-letter',
            icon: 'TextSnippet', //icons.TextSnippet,
            breadcrumbs: false,
            roles: ['user', 'subuser', 'member', 'supervisor', 'admin', 'demo', 'sales', 'superadmin', 'it'],
        }
    ]
};

export default documentGenerator;
